import { render, staticRenderFns } from "./AppAgmPrivacy.vue?vue&type=template&id=ed4074a0&scoped=true"
var script = {}
import style0 from "./AppAgmPrivacy.vue?vue&type=style&index=0&id=ed4074a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4074a0",
  null
  
)

export default component.exports